module.exports = __webpack_public_path__ + "img/mermaid.6a4cb671.jpg";